export type Country = { value: string; label: string; flag: string };

export const COUNTRIES: Country[] = [
  { value: "HN", label: "Honduras", flag: "🇭🇳" },
  { value: "GT", label: "Guatemala", flag: "🇬🇹" },
  { value: "SV", label: "El Salvador", flag: "🇸🇻" },
  { value: "NI", label: "Nicaragua", flag: "🇳🇮" },
  { value: "CR", label: "Costa Rica", flag: "🇨🇷" },
  { value: "PA", label: "Panamá", flag: "🇵🇦" },
  { value: "BZ", label: "Belice", flag: "🇧🇿" },
  { value: "MX", label: "México", flag: "🇲🇽" },
  { value: "US", label: "Estados Unidos", flag: "🇺🇸" },
  { value: "CA", label: "Canadá", flag: "🇨🇦" },
  { value: "CO", label: "Colombia", flag: "🇨🇴" },
  { value: "VE", label: "Venezuela", flag: "🇻🇪" },
  { value: "EC", label: "Ecuador", flag: "🇪🇨" },
  { value: "PE", label: "Perú", flag: "🇵🇪" },
  { value: "BO", label: "Bolivia", flag: "🇧🇴" },
  { value: "CL", label: "Chile", flag: "🇨🇱" },
  { value: "AR", label: "Argentina", flag: "🇦🇷" },
  { value: "UY", label: "Uruguay", flag: "🇺🇾" },
  { value: "PY", label: "Paraguay", flag: "🇵🇾" },
  { value: "BR", label: "Brasil", flag: "🇧🇷" },
  { value: "CU", label: "Cuba", flag: "🇨🇺" },
  { value: "DO", label: "República Dominicana", flag: "🇩🇴" },
  { value: "JM", label: "Jamaica", flag: "🇯🇲" },
  { value: "HT", label: "Haití", flag: "🇭🇹" },
  { value: "PR", label: "Puerto Rico", flag: "🇵🇷" },
  { value: "ES", label: "España", flag: "🇪🇸" },
  { value: "PT", label: "Portugal", flag: "🇵🇹" },
  { value: "GB", label: "Reino Unido", flag: "🇬🇧" },
  { value: "FR", label: "Francia", flag: "🇫🇷" },
  { value: "DE", label: "Alemania", flag: "🇩🇪" },
  { value: "IT", label: "Italia", flag: "🇮🇹" },
  { value: "NL", label: "Países Bajos", flag: "🇳🇱" },
  { value: "BE", label: "Bélgica", flag: "🇧🇪" },
  { value: "CH", label: "Suiza", flag: "🇨🇭" },
  { value: "SE", label: "Suecia", flag: "🇸🇪" },
  { value: "NO", label: "Noruega", flag: "🇳🇴" },
  { value: "DK", label: "Dinamarca", flag: "🇩🇰" },
  { value: "FI", label: "Finlandia", flag: "🇫🇮" },
  { value: "PL", label: "Polonia", flag: "🇵🇱" },
  { value: "RU", label: "Rusia", flag: "🇷🇺" },
  { value: "CN", label: "China", flag: "🇨🇳" },
  { value: "JP", label: "Japón", flag: "🇯🇵" },
  { value: "KR", label: "Corea del Sur", flag: "🇰🇷" },
  { value: "IN", label: "India", flag: "🇮🇳" },
  { value: "AU", label: "Australia", flag: "🇦🇺" },
  { value: "NZ", label: "Nueva Zelanda", flag: "🇳🇿" },
  { value: "ZA", label: "Sudáfrica", flag: "🇿🇦" },
  { value: "NG", label: "Nigeria", flag: "🇳🇬" },
  { value: "EG", label: "Egipto", flag: "🇪🇬" },
  { value: "MA", label: "Marruecos", flag: "🇲🇦" },
  { value: "IL", label: "Israel", flag: "🇮🇱" },
  { value: "TR", label: "Turquía", flag: "🇹🇷" },
  { value: "SA", label: "Arabia Saudita", flag: "🇸🇦" },
  { value: "AE", label: "Emiratos Árabes Unidos", flag: "🇦🇪" },
];

// Normalize stored values to ISO code
// Handles legacy free-text (e.g. "Honduras") and ISO codes (e.g. "HN")
export function normalizeCountryCode(raw: string | undefined): string {
  if (!raw) return "HN";
  const upper = raw.trim().toUpperCase();
  // Direct ISO match
  if (COUNTRIES.some((c) => c.value === upper)) return upper;
  // Label match (case-insensitive)
  const byLabel = COUNTRIES.find(
    (c) => c.label.toLowerCase() === raw.trim().toLowerCase(),
  );
  return byLabel?.value ?? "HN";
}
